module.exports = __webpack_public_path__ + "img/ca-bc.532014e3.svg";